<fieldset [ngModelGroup]="groupname">
    <!-- Country -->
    <mat-form-field class="w-100">
        <mat-label for="countryISOCode">
            {{ 'copy.label.FEATURES.ADDRESS.countrylabel' | copy | async }}</mat-label>
        <mat-select name="countryISOCode" id="countryISOCode" aria-label="countryISOCode"
            [(ngModel)]="address.CountryISOCode" #Country="ngModel" [required]="isRequired" matNativeControl (ngModelChange)="countryChange()">
            <mat-option *ngFor="let obj of countryList" [value]="obj.code">
                {{ obj.name }}
            </mat-option>
        </mat-select>
        <mat-error><app-validation [object]="Country" [isRequired]=isRequired></app-validation></mat-error>
    </mat-form-field>
    <!-- Resident Country -->
    <div class="w-100 required" *ngIf="resident">
        <label for="varCountryYesNo">
            {{ 'copy.label.FEATURES.ADDRESS.countryofres' | copy | async }}</label>
        <mat-radio-group [(ngModel)]="attendee.$mtcvarCountryOfRes" name="varCountryYesNo_{{address.AddressType}}"
            #varCountryYesNo="ngModel" matNativeControl [required]="isRequired"
            (ngModelChange)="setCountryOfResidence()">
            <mat-radio-button value="Yes">Yes</mat-radio-button>
            <mat-radio-button value="No">No</mat-radio-button>
            <div class="w-100">
                <small class="text-danger"><app-validation [object]="varCountryYesNo" [isRequired]=isRequired></app-validation></small>
            </div>
        </mat-radio-group>
    </div>
    <mat-form-field class="w-100"
        *ngIf="(attendee.$mtcvarCountryOfRes === 'No')">
        <mat-label for="ResidenceCountryISOCode">
            {{ 'copy.label.FEATURES.ADDRESS.countryofreslist' | copy | async }}</mat-label>
        <mat-select name="ResidenceCountryISOCode_{{address.AddressType}}" id="ResidenceCountryISOCode"
            aria-label="ResidenceCountryISOCode" [(ngModel)]="attendee.ResidenceCountryISOCode"
            #ResidenceCountryISOCode="ngModel" [required]="isRequired" matNativeControl>
            <mat-option *ngFor="let obj of countryList" [value]="obj.code">
                {{ obj.name }}
            </mat-option>
        </mat-select>
        <mat-error><app-validation [object]="ResidenceCountryISOCode" [isRequired]=isRequired></app-validation></mat-error>
    </mat-form-field>

    <!-- Address Line 1 -->
    <mat-form-field class="w-100 mb-0">
        <mat-label for="AddressLine1" [ngClass]="{'active' : address.AddressLine1}">
            {{ 'copy.label.FEATURES.ADDRESS.line1label' | copy | async }}</mat-label>
        <input matInput name="AddressLine1" id="AddressLine1" aria-label="AddressLine1"  type="text"
            maxlength="40" pattern="^[\w\s!@\-\_:',.\/?]*" [(ngModel)]="address.AddressLine1" #addressLine1="ngModel"
            [required]="isRequired" />
        <mat-error><app-validation [object]="addressLine1" [isRequired]=isRequired pattern="alphanum"></app-validation></mat-error>
    </mat-form-field>

    <!-- Address Line 2 -->
    <mat-form-field class="w-100 mt-0">
        <mat-label for="AddressLine2" [ngClass]="{'active' : address.AddressLine2}">
            {{ 'copy.label.FEATURES.ADDRESS.line2label' | copy | async }}</mat-label>
        <input matInput name="AddressLine2" aria-label="AddressLine2"  type="text"
            maxlength="40" pattern="^[\w\s!@\-\_:',.\/?]*" [(ngModel)]="address.AddressLine2" #addressLine2="ngModel" />
        <mat-error><app-validation [object]="addressLine2" [isRequired]=false pattern="alphanum"></app-validation></mat-error>
    </mat-form-field>

    <!-- Zip -->
    <mat-form-field class="w-100" *ngIf="address.CountryISOCode === 'US'" >
        <mat-label for="Zip" [ngClass]="{'active' : address.Zip}">
            {{ 'copy.label.FEATURES.ADDRESS.ziplabel' | copy | async }}</mat-label>
        <input matInput name="Zip" id="Zip" aria-label="Zip"  type="text" maxlength="14"
            pattern="^[0-9]{5}$" [(ngModel)]="address.Zip" #zip="ngModel" [required]="isRequired"
            (ngModelChange)="zipChange(zip)" />
        <mat-error><app-validation [object]="zip" [isRequired]=isRequired pattern="uszip"></app-validation></mat-error>
    </mat-form-field>
    <mat-form-field class="w-100" *ngIf="address.CountryISOCode === 'CA'" >
        <mat-label for="Zip" [ngClass]="{'active' : address.Zip}">
            {{ 'copy.label.FEATURES.ADDRESS.ziplabel' | copy | async }}</mat-label>
        <input matInput name="Zip" id="Zip" aria-label="Zip"  type="text" maxlength="14"
            pattern="^([a-zA-Z][0-9][a-zA-Z]){1}[ ]{0,1}([0-9][a-zA-Z][0-9]){1}$" [(ngModel)]="address.Zip" #zip="ngModel" [required]="isRequired"
            (ngModelChange)="zipChange(zip)" />
        <mat-error><app-validation [object]="zip" [isRequired]=isRequired pattern="cazip"></app-validation></mat-error>
    </mat-form-field>

    <mat-form-field class="w-100" *ngIf="address.CountryISOCode !== 'CA' && address.CountryISOCode !== 'US'">
        <mat-label for="Zip" [ngClass]="{'active' : address.Zip}">
            {{ 'copy.label.FEATURES.ADDRESS.ziplabel' | copy | async }}</mat-label>
        <input matInput name="Zip" id="Zip" aria-label="Zip" type="text" maxlength="14"
        pattern="^[\w\s!@\-\_:',.\/?]*" [(ngModel)]="address.Zip" #zip="ngModel" (ngModelChange)="zipChange(zip)" />
        <mat-error><app-validation [object]="zip" pattern="integer"></app-validation></mat-error>
    </mat-form-field>

    <!-- City -->
    <mat-form-field class="w-100">
        <mat-label for="City" [ngClass]="{'active' : address.City}">
            {{ 'copy.label.FEATURES.ADDRESS.citylabel' | copy | async }}</mat-label>
        <input matInput name="City" id="City" aria-label="City"  type="text" maxlength="25"
        pattern="^[A-Za-z\s\-\_'.]*$" [(ngModel)]="address.City" #city="ngModel" [required]="isRequired" />
        <mat-error><app-validation [object]="city" [isRequired]=isRequired pattern="alpha"></app-validation></mat-error>
    </mat-form-field>

    <!-- State -->
    <div *ngIf="address.CountryISOCode === 'US'">
        <mat-form-field class="w-100 required">
            <mat-label for="state">
                {{ 'copy.label.FEATURES.ADDRESS.USstatelabel' | copy | async }}</mat-label>
            <mat-select name="state" [(ngModel)]="address.StateProvince" #stateProvince="ngModel"
                [required]="isRequired" matNativeControl>
                <mat-option *ngFor="let obj of stateList" [value]="obj.code">
                    {{obj.name}}</mat-option>
            </mat-select>
            <mat-error><app-validation [object]="stateProvince" [isRequired]=isRequired></app-validation></mat-error>
        </mat-form-field>
    </div>
    <div *ngIf="address.CountryISOCode === 'CA'">
        <mat-form-field class="w-100 required">
            <mat-label for="state">
                {{ 'copy.label.FEATURES.ADDRESS.CAstatelabel' | copy | async }}</mat-label>
            <mat-select name="state" [(ngModel)]="address.StateProvince" #stateProvince="ngModel"
                [required]="isRequired" matNativeControl>
                <mat-option *ngFor="let obj of provinceList" [value]="obj.code">
                    {{obj.name}}
                </mat-option>
            </mat-select>
        </mat-form-field>
        <mat-error><app-validation [object]="stateProvince" [isRequired]=isRequired></app-validation></mat-error>
    </div>
    <mat-form-field class="w-100" *ngIf="address.CountryISOCode !== 'CA' && address.CountryISOCode !== 'US'">
        <mat-label for="State" [ngClass]="{'active' : address.StateProvince}">
            {{ 'copy.label.FEATURES.ADDRESS.OTHstatelabel' | copy | async }}</mat-label>
        <input matInput name="State" id="State" aria-label="State"  type="text" maxlength="25"
        pattern="^[\w\s!@\-\_:',.\/?]*" [(ngModel)]="address.StateProvince" #stateProvince="ngModel"
             />

        <mat-error><app-validation [object]="stateProvince" pattern="alphanum"></app-validation></mat-error>
    </mat-form-field>
</fieldset>
